import { render, staticRenderFns } from "./LogoutPage.vue?vue&type=template&id=6904f086&"
import script from "./LogoutPage.vue?vue&type=script&lang=js&"
export * from "./LogoutPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports